import { LoadingSpinner } from "./LoadingSpinner";

export const CenterPageLoader = () => {
	return (
		<div className="flex h-full w-full items-center justify-center text-primary-strong">
			<LoadingSpinner />
		</div>
	);
};
